angular.module('uiManager')
  .factory('uiManagerFactory',uiManagerFactory);

uiManagerFactory.$inject = ['$location'];
function uiManagerFactory($location){
  var isFullScreenLoading = false;
  var minute = 60;
  var logoutCount = 10 * minute;
  var logoutable = false;
  var logoutPromise = null;
  var lastUsed = moment();
  var loader = {
    isFullScreenLoading: isFullScreenLoading,
    showLoader: showLoader,
    hideLoader: hideLoader
  };

  var loginManager = {
    askUserForNewPin: false,
    askUserForExistingPin: false,
    informUserNeedNewLogin: false
  };

  var uiManager = {
    loader: loader,
    goToPage: goToPage,
    sendToLogin: sendToLogin,
    loginManager: loginManager,
    logoutCount: logoutCount,
    lastUsed: lastUsed,
    logoutable: logoutable,
    logoutPromise: logoutPromise
  };
  return uiManager;

  function sendToLogin(currentLogin){
    if((!currentLogin.validated) || (!currentLogin.user)){
      goToPage('/login');
    }
  }

  function showLoader(){
    isFullScreenLoading = true;
  }

  function hideLoader(){
    isFullScreenLoading = false;
  }

  function goToPage(page){
     $location.path(page);
  }
}
